import { Pipe, PipeTransform } from '@angular/core';
import { IUnit } from '../interfaces/unit';
import { TorqueUnits } from '../models/torque-units';

@Pipe({
  name: 'lbftToTorque',
  standalone: true
})
export class LbftTorquePipe implements PipeTransform {

  transform(value: number, units: IUnit, decimals: number = 2): number | null {
    return parseFloat(TorqueUnits.lbftToTorque(value, units.display).toFixed(decimals));

  }

}
